import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgNya = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1.62 12.215V9.75H9.336v1.82c0 .289.006.53.013.634h-.013a6 6 0 0 0-.271-.555L7.993 9.75H7v4.465h1.042v-1.912c0-.194-.006-.381-.01-.5l-.002-.117h.012l.003.007c.038.09.124.29.268.548l1.11 1.974zm3.942-4.465h-1.32l-.512 1.51h-.012l-.512-1.51h-1.32l1.221 2.75v1.715h1.234V12.5zm2.27 0 1.387 4.465h-1.29l-.19-.765h-1.283l-.191.765h-1.289l1.387-4.465zm-1.154 2.812h.839l-.309-1.221a5 5 0 0 1-.104-.573h-.013a5 5 0 0 1-.105.573z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgNya;
